import { motion } from 'framer-motion';

interface AnimationStarBeamProps {
  animate?: boolean;
}

const AnimationStarBeam = ({ animate = true }: AnimationStarBeamProps) => {
  const beamStyle = {
    background:
      'linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFF 50%, rgba(255,255,255,0) 100%)',
    backgroundSize: '100% 200%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center 0%' as const
  };

  if (!animate) {
    return (
      <div className="mb-[10px] flex flex-col items-center">
        <div className="w-[1px] h-[107px] mb-[-20px]" style={beamStyle} />
        <img
          src="/assets/scene/beam_star.png"
          alt=""
          className="w-[27px] h-[34px]"
        />
      </div>
    );
  }

  return (
    <div className="mb-[10px] flex flex-col items-center">
      <motion.div
        className="w-[1px] h-[107px] mb-[-20px]"
        style={beamStyle}
        initial={{ backgroundPosition: 'center 200%' }}
        animate={{ backgroundPosition: 'center 0%' }}
        transition={{ delay: 0.3, duration: 0.6, ease: 'linear' }}
      />
      <motion.img
        src="/assets/scene/beam_star.png"
        alt=""
        className="w-[27px] h-[34px]"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          delay: 0.9,
          duration: 0.3,
          ease: 'easeOut'
        }}
      />
    </div>
  );
};

export default AnimationStarBeam;
